import React,{Component} from 'react';

export class Footer extends Component {
	render(){
		return (
			<footer role="contentinfo" className="row" id="footer">
				<div className="container">
					<div className="col-xs-6">
						<p className="footer-left">OSAH 2019 All Rights Reserved.</p>
					</div>
					<div className="col-xs-6">
						<p className="footer-right">Designed and Developed by <a target="_blank" href="https://azularc.com/">Azul Arc</a></p>
					</div>
				</div>
			</footer>
		)
	}
}
